import { useEffect, useState } from 'react';
import { Button } from '../../../../components/ui/button';
import { generateGameDescription } from '../../../../helpers/gameDescription';
import type { GameBannerProps } from './types';
import { resolveBannerBackgroundStyle, resolveBannerDescriptionText } from './utils';

import styles from './GameBanner.module.css';

export function GameBanner({ game, description, onBack, onPlay }: GameBannerProps) {
    const [logoFailed, setLogoFailed] = useState(false);
    const resolvedDescription = resolveBannerDescriptionText(
        description,
        generateGameDescription(game)
    );
    const backgroundStyle = resolveBannerBackgroundStyle(game.backgroundImagePath);
    const showLogo = Boolean(game.logoImagePath) && !logoFailed;

    useEffect(() => {
        setLogoFailed(false);
    }, [game.id]);

    return (
        <section className={styles.banner} style={backgroundStyle}>
            <div className={styles.bannerOverlay} aria-hidden="true" />
            <div className={styles.bannerInner}>
                <button className={styles.backLink} type="button" onClick={onBack}>
                    &lt; BACK TO &quot;GAMES&quot;
                </button>

                <div className={styles.bannerContent}>
                    <div className={styles.bannerText}>
                        <h1 className={styles.title}>{game.name}</h1>
                        <p className={styles.description}>{resolvedDescription}</p>
                        {!game.comingSoon ? (
                            <Button
                                className={styles.playButton}
                                variant="primary"
                                color="yellow"
                                size="md"
                                onClick={onPlay}
                            >
                                Play Now
                            </Button>
                        ) : null}
                    </div>

                    <div className={styles.bannerLogoWrap}>
                        {showLogo ? (
                            <img
                                src={game.logoImagePath ?? undefined}
                                alt={`${game.name} Logo`}
                                className={styles.bannerLogo}
                                onError={() => setLogoFailed(true)}
                            />
                        ) : (
                            <div className={styles.logoPlaceholder}>{game.name.charAt(0)}</div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
